import React, { useState } from 'react';
import { bool, func } from 'prop-types';
import { useIntl } from 'react-intl';
import AlertTriangleYellow from '../../../../../main/resources/images/alert-triangle-yellow28.svg';
import QuestionMarkCircle from '../../../../../main/resources/images/question-mark-circle28.svg';
import Button from '../../../global/atoms/button';
import GlobalModal from '../../../global/atoms/globalModal/GlobalModal';
import { headerDatalocator } from './headerDataLocator';
import { MODAL_TYPE } from '../../../cca/constants';
import { ENV_CONFIG } from '../../../../constants/envConfig';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../../constants/analyticsConstants/Ecommerce';
import './header.scss';
import { convertPhoneNumberAsPerSbmChannel } from '../../utils/commonUtils';

const Header = props => {
    const {
        onBackClick,
        onExitClick,
        isHeaderBackExitHelpVisible,
        modalOpenEvent,
        modalCloseEvent,
        completedAnalyticEvent,
        isCCA
    } = props;
    const [isHelpModal, setIsHelpModal] = useState(false);
    const [isExitModal, setIsExitModal] = useState(false);
    const intl = useIntl();
    const {
        COMMERCIAL_CREDIT_LABEL: ccaHeader,
        COMMERCIAL_CREDIT_EXIT_LABEL: ccaExitLabel,
        COMMERCIAL_CREDIT_HELP_LABEL: ccaHelpLabel,
        COMMERCIAL_CREDIT_HELP_IMAGE: ccaHelpIcon,
        COMMERCIAL_CREDIT_EXIT_IMAGE: ccaExitIcon,
        COMMERCIAL_CREDIT_BACK_IMAGE: ccaBackIcon,
        COMMERCIAL_CREDIT_BACK_ARIA_LABEL: ccaBackAriaLabel,
        COMMERCIAL_CREDIT_HELP_ARIA_LABEL: ccaHelpAriaLabel,
        COMMERCIAL_CREDIT_EXIT_ARIA_LABEL: ccaExitArialLabel,
        HELP_SUPPORT_MODAL_PRIMARY_BUTTON_LABEL: helpModalPrimaryLabel,
        HELP_SUPPORT_MODAL_SECONDARY_BUTTON_LABEL: helpModalSecondaryLabel,
        HELP_SUPPORT_MODAL_SECONDARY_BUTTON_PHONE_NUMBER_LABEL: helpModalPhoneNumberLabel,
        EXIT_MODAL_MODAL_PRIMARY_BUTTON_LABEL: exitModalPrimaryLabel,
        EXIT_MODAL_MODAL_SECONDARY_BUTTON_LABEL: exitModalSecondaryLabel,
        HELP_SUPPORT_MODAL_TITLE: helpModalTitle,
        HELP_SUPPORT_MODAL_TEXT: helpModalText,
        EXIT_MODAL_TITLE: ccaExitModalTitle,
        EXIT_MODAL_TEXT: ccaExitModalText
    } = ENV_CONFIG || {};
    const {
        cca_header_back_button_testid,
        cca_header_help_modal_button_testid,
        cca_header_exit_modal_button_testid,
        cca_header_title_testid,
        cca_help_modal_title_testid,
        cca_exit_modal_title_testid
    } = headerDatalocator;

    const phoneNumber = convertPhoneNumberAsPerSbmChannel(helpModalPhoneNumberLabel);

    const handleHelpModal = () => {
        setIsHelpModal(true);
        modalOpenEvent(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_VIEWED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL_HELP,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
            '',
            ''
        );
    };

    const handleHelpModalClose = () => {
        setIsHelpModal(false);
        modalCloseEvent(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CTA_CLICKED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_CLOSE,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_BUTTON,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL,
            window.location.href
        );
    };

    const handleExitModalClose = isSecondaryCall => {
        setIsExitModal(!isExitModal);
        if (isSecondaryCall) {
            completedAnalyticEvent(MODAL_TYPE.EXIT, exitModalSecondaryLabel);
        } else {
            modalCloseEvent(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CTA_CLICKED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_CLOSE,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_BUTTON,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL,
                window.location.href
            );
        }
    };

    const handleExitModal = () => {
        setIsExitModal(!isExitModal);
        modalOpenEvent(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_VIEWED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL_EXIT,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
            '',
            ''
        );
    };

    const handleExitAccountCreationButtonClick = () => {
        setIsExitModal(!isExitModal);
        completedAnalyticEvent(MODAL_TYPE.EXIT, exitModalPrimaryLabel);
        onExitClick();
    };

    const launchLiveChatBox = () => {
        LiveChatWidget.call('maximize');
        setIsHelpModal(false);
        completedAnalyticEvent(MODAL_TYPE.HELP, helpModalPrimaryLabel);
    };

    const handleBackClick = () => {
        onBackClick();
    };

    const exitTitle = () => {
        return (
            <>
                {ccaExitModalTitle && (
                    <>
                        <AlertTriangleYellow className="exitmodal__title-icon" tabIndex={'-1'} aria-hidden={true} />
                        <span className="exitmodal__title" data-testid={cca_exit_modal_title_testid}>
                            {ccaExitModalTitle}
                        </span>
                    </>
                )}
            </>
        );
    };
    const helpTitle = () => {
        return (
            <>
                {helpModalTitle && (
                    <>
                        <QuestionMarkCircle className="exitmodal__title-icon" tabIndex={'-1'} aria-hidden={true} />
                        <span className="helpmodal__title" data-testid={cca_help_modal_title_testid}>
                            {helpModalTitle}
                        </span>
                    </>
                )}
            </>
        );
    };

    const helpContent = () => {
        return (
            <>
                <div className="helpmodal__content" tabIndex={'0'}>
                    {helpModalText && <p>{helpModalText}</p>}
                </div>
                <div className="helpmodal__actions">
                    {helpModalPrimaryLabel && (
                        <Button
                            tabIndex={0}
                            buttonAriaLabel={helpModalPrimaryLabel}
                            className={`button button-primary button-block`}
                            onClick={launchLiveChatBox}>
                            {helpModalPrimaryLabel}
                        </Button>
                    )}
                    {helpModalSecondaryLabel && (
                        <a
                            href={`tel:${phoneNumber}`}
                            aria-label={`${intl.formatMessage({ id: 'account:ac-common-click-here-msg' })} ${
                                helpModalSecondaryLabel + ' ' + phoneNumber
                            }`}
                            className={'button button-outline-primary button-block '}
                            onClick={() =>
                                completedAnalyticEvent(
                                    MODAL_TYPE.HELP,
                                    `${helpModalSecondaryLabel} ${phoneNumber}`
                                )
                            }>
                            {helpModalSecondaryLabel + ' ' + phoneNumber}
                        </a>
                    )}
                </div>
            </>
        );
    };

    const exitContent = () => {
        return (
            <>
                <div className="helpmodal__content" tabIndex={'0'}>
                    {ccaExitModalText && <p>{ccaExitModalText}</p>}
                </div>
                <div className="exitmodal__actions">
                    {exitModalPrimaryLabel && (
                        <Button
                            tabIndex={0}
                            buttonAriaLabel={exitModalPrimaryLabel}
                            className={`button button-primary button-block`}
                            onClick={handleExitAccountCreationButtonClick}>
                            {exitModalPrimaryLabel}
                        </Button>
                    )}
                    {exitModalSecondaryLabel && (
                        <Button
                            tabIndex={0}
                            buttonAriaLabel={exitModalSecondaryLabel}
                            className={'button button-outline-primary button-block'}
                            onClick={() => handleExitModalClose(true)}>
                            {exitModalSecondaryLabel}
                        </Button>
                    )}
                </div>
            </>
        );
    };
    return (
        <>
            <div>
                <div className="cca-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-3">
                                {!isHeaderBackExitHelpVisible && ccaBackIcon && (
                                    <Button
                                        dataTestid={cca_header_back_button_testid}
                                        customButtonAriaLabel={ccaBackAriaLabel}
                                        className="cca-header__back"
                                        onClick={handleBackClick}>
                                        <img src={ccaBackIcon} alt="" aria-hidden="true" tabIndex={'-1'} />
                                    </Button>
                                )}
                            </div>

                            <div className="header_center col-lg-8 col-md-8 col-6">
                                <h1 className="cca-header__title" data-testid={cca_header_title_testid}>
                                    {ccaHeader}
                                </h1>
                            </div>
                            <div className="col-lg-2 col-md-2 col-3">
                                <div className="cca-header__action">
                                    {!isHeaderBackExitHelpVisible && (
                                        <>
                                            {ccaHelpLabel && (
                                                <Button
                                                    dataTestid={cca_header_help_modal_button_testid}
                                                    className="button"
                                                    onClick={handleHelpModal}
                                                    customButtonAriaLabel={ccaHelpAriaLabel}>
                                                    <img src={ccaHelpIcon} alt="" aria-hidden="true" tabIndex={'-1'} />
                                                    <span className="cca-header__action-text">{ccaHelpLabel}</span>
                                                </Button>
                                            )}
                                            {ccaExitLabel && (
                                                <Button
                                                    dataTestid={cca_header_exit_modal_button_testid}
                                                    className="button"
                                                    onClick={handleExitModal}
                                                    customButtonAriaLabel={ccaExitArialLabel}>
                                                    <img src={ccaExitIcon} alt="" aria-hidden="true" tabIndex={'-1'} />
                                                    <span className="cca-header__action-text">{ccaExitLabel}</span>
                                                </Button>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <GlobalModal
                className={'width-327'}
                isOpen={isHelpModal}
                onRequestClose={handleHelpModalClose}
                title={helpTitle()}
                portalClassName={'cca-help-modal'}
                content={helpContent()}
                handleClose={handleHelpModalClose}
            />

            <GlobalModal
                className={'width-327'}
                isOpen={isExitModal}
                onRequestClose={() => handleExitModalClose(false)}
                title={exitTitle()}
                portalClassName={'cca-exit-modal'}
                content={exitContent()}
                handleClose={() => handleExitModalClose(false)}
            />
        </>
    );
};

Header.propTypes = {
    onExitClick: func,
    isHeaderBackExitHelpVisible: bool,
    isCCA: bool,
    onBackClick: func,
    modalOpenEvent: func,
    modalCloseEvent: func,
    completedAnalyticEvent: func
};

Header.defaultProps = {
    isHeaderBackExitHelpVisible: false,
    isCCA: false,
    onBackClick: () => {},
    onExitClick: () => {},
    modalOpenEvent: () => {},
    modalCloseEvent: () => {},
    completedAnalyticEvent: () => {}
};

export default Header;
